export class IncidenteRequest {
    idOs: number;
    idUsuario: number;
}